import React from "react";
import "./Footer.scss";
import { FaPhoneAlt, FaFacebook, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import logo1 from "../../assets/images/svg/app-left-logo.svg";
import logo2 from "../../assets/images/svg/app-right-logo.svg";

const Footer = () => {
  const handleCityClick = (city) => {
    const venturesSection = document.getElementById("ventures");
    if (venturesSection) {
      venturesSection.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        const event = new CustomEvent("citySelected", { detail: city });
        window.dispatchEvent(event);
      }, 500);
    }
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer id="footer" className="footer">
      <div className="footer__top">
        <div className="footer__map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.871456752467!2d78.3737699749366!3d17.465865483434744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93601f330a79%3A0xc3a98351aa48df88!2sAbhinandana%20Digi%20Branch%20-%20Abhinandana%20Avenues%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1753424625878!5m2!1sen!2sin" 
          title="Company Location" loading="lazy">
          </iframe>
        </div>

        <div className="footer__contact-group">
          <div className="footer__contact-box">
            <p className="footer__contact-title">Customer Support</p>
            <p className="footer__contact-info">
              <FaPhoneAlt /> 9115 966 966 <br />
            </p>
          </div>

          <div className="footer__contact-box">
            <p className="footer__contact-title">Channel Partner Support</p>
            <p className="footer__contact-info">
              <FaPhoneAlt /> 9115 977 977
            </p>
          </div>

          <div className="footer__contact-box">
            <p className="footer__contact-title">Marketing</p>
            <p className="footer__contact-info">
              <FaPhoneAlt /> 9115 988 988 <br />
            </p>
          </div>
        </div>
      </div>

      <div className="footer__divider"></div>

      <div className="footer__bottom">
        <div className="footer__info">
          <div className="footer__logos">
            <img src={logo2} alt="Abhinandana Avenues" className="footer__logo" />
            <img src={logo1} alt="Abhinandana Group" className="footer__logo" />
          </div>
          <div className="footer__address">
            <h4>Contact Us</h4>
            <p>Call: 1800571118</p>
            <p>
              Flat No. 101, 1st Floor, JG’s Aishwarya Apartments, Shilpa Hills,
              Hitex Road, Khanamet, Hyderabad - 500084
            </p>
            <p>Email: abhinandanadigi@gmail.com</p>
          </div>
        </div>

        <div className="footer__links">
          <div className="footer__link-group">
            <h4>EXPLORE</h4>
            <ul>
              <li><span onClick={() => scrollToSection("home")}>Home</span></li>
              <li><span onClick={() => scrollToSection("about")}>About</span></li>
              <li><span onClick={() => scrollToSection("ventures")}>Ventures</span></li>
              <li><span onClick={() => scrollToSection("services")}>Services</span></li>
              <li><span onClick={() => scrollToSection("developments")}>Developments</span></li>
              <li><span onClick={() => scrollToSection("awards")}>Awards</span></li>
            </ul>
          </div>

          <div className="footer__link-group">
            <h4>VENTURES</h4>
            <ul>
              <li onClick={() => handleCityClick("Hyderabad")}>Hyderabad</li>
              <li onClick={() => handleCityClick("Vijayawada")}>Vijayawada</li>
              <li onClick={() => handleCityClick("")}>Vizag</li>
              <li onClick={() => handleCityClick("Chennai")}>Chennai</li>
              <li onClick={() => handleCityClick("Bangalore")}>Bangalore</li>
            </ul>
          </div>

          <div className="footer__social">
            <h4>Social Media</h4>
            <div className="footer__icons">
              <a href="https://www.facebook.com/share/17WxxAkeZ8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                <FaFacebook color="#708037" size={24} />
              </a>
              <a href="https://instagram.com/abhinandanaofficial" target="_blank" rel="noopener noreferrer">
                <AiFillInstagram color="#708037" size={24} />
              </a>
              <a href="https://api.whatsapp.com/send?phone=919115966966" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp color="#708037" size={24} />
              </a>
              <a href="https://www.youtube.com/@AbhinandanaAvenues" target="_blank" rel="noopener noreferrer">
                <FaYoutube color="#708037" size={24} />
              </a>
            </div>
            <button className="footer__cta">Learn More</button>
          </div>
        </div>
      </div>

      <div className="footer__copyright">
        © 2025 Abhinandana Pvt. Ltd. All rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
